/* eslint-disable class-methods-use-this */
import { PagedResultDto } from '../dto/pagedResultDto';
import http from '../httpService';
import {
  BillingPortalInput,
  BillingPortalResult,
  CreditBalance,
  CreditPack,
  CreditTransaction,
  GetCreditTransactionsInput,
  PurchaseCreditsInput,
  PurchaseCreditsResult,
} from './dto/credit';

class CreditService {
  public async getBalance(): Promise<CreditBalance> {
    const result = await http.get('api/services/app/Credit/GetBalance');
    return result.data.result;
  }

  public async getCreditPacks(): Promise<CreditPack[]> {
    const result = await http.get('api/services/app/Credit/GetCreditPacks');
    return result.data.result;
  }

  public async getTransactions(
    input: GetCreditTransactionsInput
  ): Promise<PagedResultDto<CreditTransaction>> {
    const result = await http.get('api/services/app/Credit/GetTransactions', { params: input });
    return result.data.result;
  }

  public async purchaseCredits(input: PurchaseCreditsInput): Promise<PurchaseCreditsResult> {
    const result = await http.post('api/services/app/Credit/PurchaseCredits', input);
    return result.data.result;
  }

  public async getBillingPortalUrl(input: BillingPortalInput): Promise<BillingPortalResult> {
    const result = await http.get('api/services/app/Credit/GetBillingPortalUrl', { params: input });
    return result.data.result;
  }
}

export default new CreditService();
